import { E_CompanyChargeMode } from '@/apis/service/CompanyApi.types';
/* 公司的类型 */
export const companyType = [
    { value: E_CompanyChargeMode.COMMERCIAL, text: 'backoffice.company.customersPaying' },
    { value: E_CompanyChargeMode.TRIAL, text: 'backoffice.company.customerTry' },
    { value: E_CompanyChargeMode.COOPERATIVE, text: 'backoffice.company.coperated' },
    { value: E_CompanyChargeMode.INTERNAL, text: 'backoffice.company.internalTesting' },
    { value: E_CompanyChargeMode.FREE, text: 'enum.E_CompanyChargeMode.FREE' },
    { value: E_CompanyChargeMode.NOT_RENEW, text: 'enum.E_CompanyChargeMode.NOT_RENEW' }
];
export const EChargeMode = {
    // 未知
    UNKNOWN: 'UNKNOWN',
    // 商业
    COMMERCIAL: 'COMMERCIAL',
    // 使用
    TRIAL: 'TRIAL',
    // 免费
    FREE: 'FREE',
    // 历史
    HISTORICAL: 'HISTORICAL',
    // 内置
    INTERNAL: 'INTERNAL',
    // 测试
    BETA: 'BETA',
    // FREEMIUM
    FREEMIUM: 'FREEMIUM',
};
export var E_ChargeMode;
(function (E_ChargeMode) {
    // 未知
    E_ChargeMode["UNKNOWN"] = "UNKNOWN";
    // 商业
    E_ChargeMode["COMMERCIAL"] = "COMMERCIAL";
    // 使用
    E_ChargeMode["TRIAL"] = "TRIAL";
    // 免费
    E_ChargeMode["FREE"] = "FREE";
    // 历史
    E_ChargeMode["HISTORICAL"] = "HISTORICAL";
    // 内置
    E_ChargeMode["INTERNAL"] = "INTERNAL";
    // 测试
    E_ChargeMode["BETA"] = "BETA";
    // FREEMIUM
    E_ChargeMode["FREEMIUM"] = "FREEMIUM";
})(E_ChargeMode || (E_ChargeMode = {}));
export const EPrivilegeStatus = {
    Expire: 'Expire',
    Normal: 'Normal',
    Disabled: 'Disabled',
};
export var E_CompanyLegitimateStatus;
(function (E_CompanyLegitimateStatus) {
    /**
     * 不合法
     */
    E_CompanyLegitimateStatus[E_CompanyLegitimateStatus["illegal"] = 0] = "illegal";
    /**
     * 合法
     */
    E_CompanyLegitimateStatus[E_CompanyLegitimateStatus["legal"] = 1] = "legal";
})(E_CompanyLegitimateStatus || (E_CompanyLegitimateStatus = {}));
/**
 * 科创评级(数据来源来源tffi的fe-dnf项目)
 */
export const SortedInnovationRatings = [
    'C',
    'CC',
    'CCC',
    'B',
    'BB',
    'BBB',
    'A',
    'AA',
    'AAA'
];
